<template>
  <div class="page">
    <div class="organization">
      <!-- <div class="page-tool-bar" style="padding: 4px;">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addMppFileFolder"
          >新建</el-button>
        </div>
      </div> -->
      <div class="add" @click="addMppFileFolder">
        <span style="padding-left: 24px;font-size: 14px;"><i class="el-icon-circle-plus-outline"></i>添加分类</span>
        <!-- <el-tree
          class="ss"
          :data="[{label:'添加分类'}]"
          node-key="id"
          default-expand-all
          :expand-on-click-node="false">
          <span @click="addMppFileFolder" class="custom-tree-node" slot-scope="{ node, data }">
            <span><i class="el-icon-circle-plus-outline"></i>{{ node.label }}</span>
          </span>
        </el-tree> -->
      </div>
      <el-tree style="display: block;font-size: 14px;" :expand-on-click-node="false" default-expand-all current-node-key="0" node-key="id" highlight-current :data="mppFileFolderList"
        :props="{ children: 'children', label: 'folderName' }" size="small">
        <div class="custom-tree-node flex items-center" style="flex: 1;" slot-scope="{ node, data }">
            <div style="display: flex;justify-content: space-between;flex:1;align-items: center;">
              <div style="display: flex;align-items: center;flex: 1;" @click="handleNodeClick(data)">
                <i class="el-icon-folder"></i>
                <span class="ml-1">{{ node.label }}</span>
              </div>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="'add',data" v-if="data.folderName != '全部文件'">新增分类</el-dropdown-item>
                  <el-dropdown-item :command="'',data" v-else="data.folderName != '全部文件'">新增分类</el-dropdown-item>
                  <el-dropdown-item :command="'edit',data" v-if="data.folderName != '全部文件'">编辑分类</el-dropdown-item>
                  <el-dropdown-item :command="'delete',data" v-if="data.folderName != '全部文件'">删除分类</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
        </div>
      </el-tree>
    </div>
    <div style="display: flex; flex-direction: column; flex: 1" class="overflow-auto">
      <!-- <div>
            <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="ID">
                  <el-input  v-model="queryForm.id"></el-input>
              </el-form-item>
              <el-form-item label="文件夹名称">
                  <el-input  v-model="queryForm.folderName"></el-input>
              </el-form-item>
              <el-form-item label="上一级文件夹">
                  <el-input  v-model="queryForm.parentId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppFileFolderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
            </el-form>
          </div> -->
      <div>
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
          class="query-form" @submit.native.prevent>
<!--          <el-form-item label="ID">-->
<!--            <el-input v-model="queryForm.id"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="文件名">-->
<!--            <el-input v-model="queryForm.fileName"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="新文件名">-->
<!--            <el-input v-model="queryForm.newFileName"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="文件类型">-->
<!--              <el-select clearable v-model="queryForm.fileType" placeholder="请选择">-->
<!--                <el-option-->
<!--                  label="图片"-->
<!--                  :value="0">-->
<!--                </el-option>-->
<!--                  <el-option-->
<!--                      label="文件"-->
<!--                      :value="1">-->
<!--                  </el-option>-->
<!--              </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="文件后缀">
<!--            <el-input v-model="queryForm.fileSuffix"></el-input>-->
              <el-select v-model="queryForm.fileSuffix" placeholder="请选择" clearable>
                <el-option
                  v-for="item in typeList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
<!--          <el-form-item label="文件路径">-->
<!--            <el-input v-model="queryForm.filePath"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="文件大小">-->
<!--            <el-input v-model="queryForm.fileSize"></el-input>-->
<!--          </el-form-item>-->
<!--          <el-form-item label="文件夹">-->
<!--              <el-select-->
<!--                  v-model="mppFileFolder.folderId"-->
<!--                  placeholder="请选择文件夹名称"-->
<!--                  :disabled="mppFileFolderState == 'check'"-->
<!--                  style="width: 200px;"-->
<!--                  size="small"-->
<!--              >-->
<!--                  <el-tree default-expand-all :data="mppFileFolderList" :props="{ children: 'children', label: 'folderName' }">-->
<!--                      <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">-->
<!--                          <el-option :label="node.label" :value="data.id"> </el-option>-->
<!--                      </div>-->
<!--                  </el-tree>-->
<!--              </el-select>-->
<!--          </el-form-item>-->
          <el-form-item>
            <el-button size="small" type="primary" icon="el-icon-search" @click="checkState = 'check'">查询</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="checkState = 'reset'">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <MppFile @getUserinfo="getUserinfo" ref="filesearch" :trees="mppFileFolderList" @isSearch="search" :queryForm="queryForm" :checkState="checkState" @resetCheckState="resetCheckState"></MppFile>
    </div>
    <!-- 搜索 -->
    <!-- <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="ID">
                  <el-input  v-model="queryForm.id"></el-input>
              </el-form-item>
              <el-form-item label="文件夹名称">
                  <el-input  v-model="queryForm.folderName"></el-input>
              </el-form-item>
              <el-form-item label="上一级文件夹">
                  <el-input  v-model="queryForm.parentId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppFileFolderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form> -->
    <!-- <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppFileFolder"
        >新建</el-button> -->
    <!-- <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppFileFolder(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppFileFolder(null)"
        >删除</el-button> -->
    <!-- </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportMppFileFolderList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppFileFolderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div> -->
    <!-- 列表数据 -->
    <!-- <el-table
      :data="mppFileFolderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="id"
        label="ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="folderName"
        label="文件夹名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="parentId"
        label="上一级文件夹"
        width="180"
      > </el-table-column> -->
    <!-- <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppFileFolder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppFileFolder(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppFileFolder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column> -->
    <!-- </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div> -->
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppFileFolderStates[mppFileFolderState]"
      :visible.sync="showDialog"
      width="400px"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppFileFolder"
          ref="mppFileFolderForm"
          :rules="rules"
          label-width="100px"
          size="small"
        >
          <el-form-item
            label="上级文件夹"
            prop="parentId"
          >
            <!-- <el-input
              size="small"
              v-model="mppFileFolder.parentId"
              :disabled="mppFileFolderState == 'check'"
            ></el-input> -->
            <el-select
                  v-model="mppFileFolder.parentId"
                  placeholder="请选择文件夹名称"
                  :disabled="mppFileFolderState == 'check'"
                  style="width: 200px;"
                  size="small"
              >
                  <el-tree default-expand-all :data="mppFileFolderList" :props="{ children: 'children', label: 'folderName' }">
                      <div class="custom-tree-node flex items-center" slot-scope="{ node, data }">
                          <el-option :label="node.label == '全部文件' ? '顶级分类' : node.label" :value="data.id"> </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="文件夹名称"
            prop="folderName"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="mppFileFolder.folderName"
              :disabled="mppFileFolderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="sort">
              <el-input size="small" style="width: 200px;" v-model="mppFileFolder.sort" :disabled="mppFileFolderState == 'check'"></el-input>
            </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppFileFolderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  <!-- </div> -->
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import MppFile from '@/components/system/MppFile.vue';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    MppFile
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        // this.resetMppFileFolderList();
        // this.getMppFileFolderList(this.queryForm);
        // this.$emit('resetCheckState');
      } else if (val == 'reset') {
        // this.resetMppFileFolderList();
        // this.getMppFileFolderList();
        // this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      checkState: '',
      queryForm:{
        id: '', //ID
        fileName: '', //文件名
        newFileName: '', //新文件名
        fileType: '', //文件类型
        fileSuffix: '', //文件后缀
        filePath: '', //文件路径
        fileSize: '', //文件大小
        folderId: '', //文件夹
      },
      loading: false,
      showDialog: false,
      currentMppFileFolderId:'',
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      mppFileFolderState: 'add',
      mppFileFolderStates: {
        add: '添加分类',
        check: '查看mpp_file_folder',
        edit: '修改分类'
      },

      multipleSelection: [],
      mppFileFolderList: [],
      mppFileFolder: {
        id: '', //ID
        folderName: '', //文件夹名称
        parentId: '0', //上一级文件夹,
        sort: '10', //排序
      },
      btnLoading: false,

      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        folderName: [{ required: true, message: '文件夹名称不能为空', trigger: 'blur' }],
        // parentId: [{ required: true, message: '上一级文件夹不能为空', trigger: 'blur' }],
        sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
      },
        typeList: [],
    };
  },
  created() {
    this.getMppFileFolderList();
  },
  methods: {
    // ss(c){
    //   console.log(c)
    // },
    handleCommand(val,data){
      console.log(val)
      console.log(data.$attrs.data.folderName)
      if(val == ''){
        this.mppFileFolder.parentId = '0'
        this.addMppFileFolder()
        return
      }
      if(val == 'add'){
        this.mppFileFolder.parentId = data.$attrs.data.id
        this.addMppFileFolder()
      }else if(val == 'edit'){
        this.editMppFileFolder(data.$attrs.data.id)
      }else{
        this.deleteMppFileFolder(data.$attrs.data.id)
      }
    },
    handleNodeClick(data) {
        this.checkState = 'check';
        console.log(data)
        this.queryForm.folderId = data.id == '0' ? null : data.id;
    },
    resetCheckState() {
      if (this.checkState == 'reset') {
          this.queryForm = {
            id: '', //ID
            fileName: '', //文件名
            newFileName: '', //新文件名
            fileType: '', //文件类型
            fileSuffix: '', //文件后缀
            filePath: '', //文件路径
            fileSize: '', //文件大小
            folderId: '', //文件夹
          };
      }
      this.checkState = '';
    },
    search(value) {
      this.isSearch = value;
    },
    resetMppFileFolderList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.mppFileFolderList = [];
    },
    resetDialog() {
      this.mppFileFolderState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        folderName: '', //文件夹名称
        parentId: '', //上一级文件夹
      };
      this.getMppFileFolderList();
    },
    closeDialog() {
      this.showDialog = false
      this.mppFileFolder = {
        id: '', //ID
        folderName: '', //文件夹名称
        parentId: '0', //上一级文件夹
        sort: '10', //排序
      };
    },
      getUserinfo(array){
        this.typeList = array
      },
    submitForm() {
      if (this.mppFileFolderState == 'add') {
        this.$refs.mppFileFolderForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/filefolder/add`, { ...this.mppFileFolder }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetMppFileFolderList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.mppFileFolderState == 'edit') {
        this.$refs.mppFileFolderForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/mpp/filefolder/edit`, { ...this.mppFileFolder }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetMppFileFolderList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addMppFileFolder() {
      this.showDialog = true;
      console.log("123")
      this.mppFileFolderState = 'add';
    },
    editOne(id){
      this.showDialog = true;
      this.mppFileFolder.parentId = id;
      this.mppFileFolderState = 'edit';
    },
    checkMppFileFolder(mppFileFolderId) {
      console.log(mppFileFolderId);
      this.currentMppFileFolderId = mppFileFolderId;

      this.getMppFileFolderById();
      this.showDialog = true;
      this.mppFileFolderState = 'check';
    },
    editMppFileFolder(mppFileFolderId) {
      console.log('mppFileFolder', mppFileFolderId);
      if (mppFileFolderId) {
        this.currentMppFileFolderId = mppFileFolderId;
        this.getMppFileFolderById();
      } else {
        this.mppFileFolder = { ...this.mppFileFolder, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.mppFileFolderState = 'edit';
    },
    deleteMppFileFolder(mppFileFolderId) {
      let ids = '';
      if (mppFileFolderId) {
        ids = mppFileFolderId;
      } else {
        ids = this.multipleSelection.map((mppFileFolder) => mppFileFolder.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/mpp/filefolder/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetMppFileFolderList();
              this.getMppFileFolderList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshMppFileFolderList() {
      this.resetMppFileFolderList();
      this.getMppFileFolderList();
    },
    getMppFileFolderList(query = {}) {
      this.loading = true;
      get(`/mpp/filefolder/findAllAsTree`, {}).then((res) => {
        this.loading = false;
        if (res.success) {
          res.treeData.unshift({id:"0",folderName:'全部文件',children:[]})
          this.mppFileFolderList = res.treeData;
          console.log(this.mppFileFolderList);
          // this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getMppFileFolderById() {
      get(`/mpp/filefolder/get`, { id: this.currentMppFileFolderId }).then((res) => {
        if (res.success) {
          this.mppFileFolder = { ...this.mppFileFolder, ...res.mppFileFolder };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportMppFileFolderList() {
      //this.btnLoading = true;
      exprotExcel(`/mpp/filefolder/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/mpp/filefolder/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/mpp/filefolder/importData`, formData);
      this.refreshMppFileFolderList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getMppFileFolderList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getMppFileFolderList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.page {
  display: flex;
  flex-direction: row;

  .organization {
    height: 100%;
    width: 240px;
    margin-right: 15px;
    padding: 10px;
    background-color: #fff;

    .add{
      width: 100%;
      height: 40px;
      display: flex;
      color: #606266;
      align-items: center;
    }

    &>div {
      display: flex;
      align-items: center;
      padding: 0 5px;
      cursor: pointer;
    }

    .operation-label {
      margin-left: 3px;
    }

    .search {
      margin: 10px 0;
    }
  }
}

// .operation {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     color: #409eff;
//     font-size: 12px;


// }</style>